
export interface INavElementsNode {
    id: string;
    group: string;
    label: string;
    titel?: string;
    typ?: string;
    art?: string;
    display?: boolean;
    isExpanded?: boolean;
    anlage?: string;
}

export class NavElementsNodeGroup {

    public _children: INavElementsNode[] = [];

    constructor(
        private _name: string
    ) { }

    // set/get
    public get name() { return this._name; }

    // add Child
    public addChild(child: INavElementsNode) {
        let exist = false;


        for (const entry of this._children) {
            if (entry.id === child.id) {
                entry.isExpanded = child.isExpanded || entry.isExpanded;
                exist = true;
                break;
            }
        }

        if (!exist) {
            this._children.push(child);
        }
    }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-elements-nodegroup.ts